<script lang="ts" setup>
import SubscribePageDefault from './components/SubscribePage.default.vue'
import SubscribePageNovelarc from './components/SubscribePage.novelarc.vue'
import SubscribePageFlipnovel from './components/SubscribePage.flipnovel.vue'
import SubscribePageStorlyn from './components/SubscribePage.storlyn.vue'
import SubscribePageTalewave from './components/SubscribePage.talewave.vue'
import SubscribePageNovelmello from './components/SubscribePage.novelmello.vue'
import { getSubscribePageConfig } from '@/composables/payment'
import { loadBrandComponent } from '@/utils/loadBrandConfig'

// 加载当前品牌配置
const config = getSubscribePageConfig()

// 加载当前品牌组件（rocnovel、oceread、ficmoon 共用 default，novelarc 用专属组件）
const SubscribePage = loadBrandComponent({
  rocnovel: SubscribePageDefault,
  oceread: SubscribePageDefault,
  ficmoon: SubscribePageDefault,
  novelarc: SubscribePageNovelarc,
  storyella: SubscribePageNovelarc,
  aurenovel: SubscribePageNovelarc,
  florastory: SubscribePageNovelarc,
  silktale: SubscribePageNovelarc,
  pearla: SubscribePageNovelarc,
  fictora: SubscribePageDefault,
  marinovel: SubscribePageDefault,
  talewave: SubscribePageTalewave,
  flipnovel: SubscribePageFlipnovel,
  moonpage: SubscribePageFlipnovel,
  novelune: SubscribePageFlipnovel,
  storlyn: SubscribePageStorlyn,
  novaris: SubscribePageStorlyn,
  novelmello: SubscribePageNovelmello,
})
</script>

<template>
  <div>
    <!-- 品牌专属页面组件 -->
    <SubscribePage :config="config" />
  </div>
</template>
